import React, { useState } from 'react';
import sideimage from "../../assets/rootimg/astrotellerlogo.png";
import authimg from "../../assets/rootimg/authimage.jpg";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { API_END_POINT } from '../Utils/Constant';

const BlogLogin = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        userid: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        
        try {
            const response = await axios.post(`${API_END_POINT}astroblogauth/blog-admin/login`, formData);
            
            if (response.data && response.data.token) {
                // Store token in localStorage
                localStorage.setItem('blogToken', response.data.token);
                localStorage.setItem('blogUser', JSON.stringify(response.data.contentWriter));
                
                // Navigate to admin dashboard
                navigate('/blog/admin');
            }
        } catch (error) {
            console.error('Login error:', error);
            setError(error.response?.data?.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleSignup = () => {
        navigate('/blog/admin-signup');
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-white to-success/40 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl w-full flex shadow-lg rounded-lg overflow-hidden">
                {/* Left side - Image */}
                <div className="hidden md:block w-1/2 bg-purple-100">
                    <img
                        src={authimg}
                        alt="Welcome"
                        className="w-full h-full object-fit"
                    />
                </div>

                {/* Right side - Form */}
                <div className="w-full md:w-1/2 bg-white p-8 flex flex-col justify-center items-center">
                    <div className="w-full max-w-md">
                        <div className="flex justify-center mb-4">
                            <div className="w-[75%] h-auto mx-auto">
                                <img
                                    src={sideimage}
                                    alt="Welcome"
                                    className="w-full h-full object-cover rounded-full"
                                />
                            </div>
                        </div>

                        <h2 className="text-center text-lg text-secondary font-bold ">Welcome to Astrotellers blog</h2>
                        <p className="text-center text-gray-600 mb-4">Please enter your details</p>

                        {error && (
                            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="space-y-6 w-full">
                            <div className="w-full">
                                <input
                                    type="text"
                                    name="userid"
                                    value={formData.userid}
                                    onChange={handleChange}
                                    placeholder="User ID"
                                    className="w-full px-3 py-2 border-b border-gray-300 focus:border-purple-500 focus:outline-none"
                                    required
                                />
                            </div>

                            <div className="relative w-full">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Password"
                                    className="w-full px-3 py-2 border-b border-gray-300 focus:border-purple-500 focus:outline-none"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-2 top-2 text-gray-500"
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-black text-white py-3 rounded-md hover:bg-secondary transition-colors mt-8"
                                disabled={loading}
                            >
                                {loading ? 'Logging in...' : 'Login'}
                            </button>

                            <p className="text-center text-gray-600 mt-6">
                                Don't have an account contact admin
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BlogLogin